import { render, staticRenderFns } from "./bullish_flag.vue?vue&type=template&id=2bcb32f3"
import script from "./bullish_flag.vue?vue&type=script&lang=js"
export * from "./bullish_flag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports